import { Component } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-success',
    imports: [
    MatButtonModule,
    MatCardModule,
    RouterModule
],
    templateUrl: './success.component.html',
    styleUrl: './success.component.css'
})
export class SuccessComponent {

}

